import type { SelectHTMLAttributes } from "react";

/**
 * G-9.2 kit: styled select. Deliberately wraps the NATIVE <select> — native
 * menus stay accessible and correct on iOS/tablets — but the closed control is
 * fully token-styled (ui.css `.kit-select`): recessed fill, hairline border,
 * custom chevron, correct colors in both themes. This is the drop-in
 * replacement for the raw OS-looking selects (AnalyticsPage, UsersPage, …).
 */
export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  const { className, children, ...rest } = props;
  return (
    <span className={className ? `kit-select ${className}` : "kit-select"}>
      <select {...rest}>{children}</select>
      <svg
        className="kit-select-chevron"
        viewBox="0 0 24 24"
        width="14"
        height="14"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </span>
  );
}
